export const DEAFULT_DOC_FIELDS = {
	STATUS: 'PmdStatusCode',
	DOC_ID: 'PmdId',
	DESCRIPTION: 'PmdrComment',
	REV_DATE: 'PmdrRevDate',
};

export const FIELD_TYPES = {
	DROPDOWN: 'dropdown',
	INPUT: 'input',
	DATE: 'date_input',
};
